import React from 'react'
import { Modal } from 'react-bootstrap'
import './styles.scss';

const ModalMessage = ({ message, onOkPress, link, linkMessage }) => {
  return (
    <>
      {message && (
        <Modal
          aria-labelledby="contained-modal-title-vcenter"
          dialogClassName="w-580"
          contentClassName="modal-main-container"
          show={true}
          centered
          onExit={() => {
            onOkPress()
          }}>
          <div className="inner-content text-center">
            <div>
              <div className="modal-title text-center">
                <p className="mb-0">{message}</p>
              </div>
              {link ? <div>
                <a href={link} target='_blank' className='anchor-tag-in-modal link-primary' rel="noreferrer">{linkMessage}</a>
              </div>: <></>
              }

              <div className="group-btns">
                <button className="custom-btn purple lg rounded" onClick={onOkPress}>
                  OK
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  )
}

export default ModalMessage
